app.config(function (httpBatchConfigProvider, API_URL) {
    var config = httpBatchConfigProvider.getBatchConfig(API_URL + '/batch');

    config.enabled = false;
});

app.constant('API_URL', window.location.protocol + '//' +  window.location.hostname + '/api');
